import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { Avatar } from 'common/components/Avatar';
import { getEmail } from 'common/helpers';
import { IUser } from 'entities/User/User.models';
import { getUserName } from 'entities/User/User.helper';

export const renderSelectUserModalRecords = () => {
  return [
    {
      key: 'avatar',
      render: (_, record) => <Avatar size={32} firstName={record.firstName} lastName={record.lastName} />,
      width: '44px',
    },
    {
      key: 'info',
      render: (_, record) => {
        return (
          <div>
            <div>{getUserName.fullName(record.lastName, record.firstName, record.patronymic)}</div>

            <div className="select-user-modal__table_item-user-email">{getEmail(record.email)}</div>
          </div>
        );
      },
    },
  ] as ColumnsType<IUser>;
};
